import { useLightboxProps } from 'yet-another-react-lightbox';
import { resolveZoomProps } from '../props';

export function useZoomProps() {
  const { zoom } = useLightboxProps();
  return resolveZoomProps(zoom);
}
